import { type AuditLightingTypeFormEntry } from '#packages/data-collection/models/audit-lighting-type-form';

import {
  LightSourceLabel,
  LampTypeLabel,
  LampBaseLabel,
  FixtureTypeLabel,
  AttributeLabel,
  ColorTemperatureLabel,
} from '#apps/client-web/features/audit-form-lighting-type/constants';

import { type ExcelTableMapping } from '../types/excel-mapping';

/**
 * Maps Lighting Type form entries to the "2. Lighting types" Excel sheet.
 *
 * Each entry occupies one row starting at row 10.
 * Column letters correspond to the template table headers.
 */
export const lightingTypeTableMapping: ExcelTableMapping<AuditLightingTypeFormEntry> = {
  label: 'Lighting Types',
  startRangeName: 'lighting_types_data_start',

  columns: [
    /* C – # of Lamps */
    {
      column: 'C',
      getValue: (e) => e.quantity,
    },
    /* D – Light Source */
    {
      column: 'D',
      getValue: (e) => (e.lightSource ? LightSourceLabel[e.lightSource] : undefined),
    },
    /* E – Lamp Type */
    {
      column: 'E',
      getValue: (e) => (e.lampType ? LampTypeLabel[e.lampType] : undefined),
    },
    /* F – Lamp Base */
    {
      column: 'F',
      getValue: (e) => (e.lampBase ? LampBaseLabel[e.lampBase] : undefined),
    },
    /* G – W (Lamp) */
    {
      column: 'G',
      getValue: (e) => e.lampWattage,
    },
    /* H – Fixture Size */
    {
      column: 'H',
      getValue: (e) => e.fixtureSize,
    },
    /* I – Fixture Type */
    {
      column: 'I',
      getValue: (e) => (e.fixtureType ? FixtureTypeLabel[e.fixtureType] : undefined),
    },
    /* J – Fixture Mount */
    {
      column: 'J',
      getValue: (e) => e.fixtureMount,
    },
    /* K – Attribute 1 */
    {
      column: 'K',
      getValue: (e) => {
        const attr = e.attributes?.[0];
        return attr ? AttributeLabel[attr] : undefined;
      },
    },
    /* L – Attribute 2 */
    {
      column: 'L',
      getValue: (e) => {
        const attr = e.attributes?.[1];
        return attr ? AttributeLabel[attr] : undefined;
      },
    },
    /* M – Colour */
    {
      column: 'M',
      getValue: (e) =>
        e.colorTemperature ? ColorTemperatureLabel[e.colorTemperature] : undefined,
    },
    /* N – Comments */
    {
      column: 'N',
      getValue: (e) => e.comments,
    },
    /* O – DCA Photo IDs */
    {
      column: 'O',
      getValue: (e) => e.attachments?.map((a) => a.name).join(', '),
    },
    /* P – Ballast Factor */
    {
      column: 'P',
      getValue: (e) => e.ballastFactor,
    },
    /* Q – W (fix) */
    // {
    //   column: 'Q',
    //   getValue: (e) => e.fixtureWattage,
    // },
    /* R – Luminaire Name (Client Facing) */
    {
      column: 'R',
      getValue: (e) => e.luminaireName,
    },
  ],
};
